import React from 'react';
import MuiLinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';

export type { LinearProgressProps };

export const LinearProgress: React.FC<LinearProgressProps> = (props) => (
  <MuiLinearProgress {...props} />
);
